/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminGetCourseDetailOptions, AdminGetCourseDetailResponses } from '../../models/AdminGetCourseDetail'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Course
 * {@link /admin/course/:course_id}
 */
export function adminGetCourseDetail<ThrowOnError extends boolean = true>(options: Options<AdminGetCourseDetailOptions, ThrowOnError>): Promise<UnwrappedResult<AdminGetCourseDetailResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/admin/course/{course_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminGetCourseDetailResponses, ThrowOnError>>
}
